import React from 'react';
import ReactDOM from 'react-dom';
import App from './layouts';

ReactDOM.render(<App />, document.getElementById('root'));
